import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { 
  NbButtonModule, 
  NbCardModule,
  NbDialogModule,
  NbIconModule, 
  NbInputModule,
  NbSelectModule,
  NbSpinnerModule,
  NbToastrModule 
} from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { HeaderContactMenuComponent } from './header-contact-menu.component';
import { MobileMessageDialogComponent } from '../mobile-message-dialog/mobile-message-dialog.component';
import { HeaderSaldeoButtonComponent } from '../header-saldeo-button/header-saldeo-button.component';
import { HeaderFakturyButtonComponent } from '../header-faktury-button/header-faktury-button.component';
import { MobileFakturyDialogComponent } from '../mobile-faktury-dialog/mobile-faktury-dialog.component';
import { SimplePlatnosciTableComponent } from '../simple-platnosci-table/simple-platnosci-table.component';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';
import { HeaderZusButtonComponent } from '../header-zus-button/header-zus-button.component';

@NgModule({
  declarations: [
    HeaderContactMenuComponent,
    MobileMessageDialogComponent,
    HeaderSaldeoButtonComponent,
    HeaderFakturyButtonComponent,
    MobileFakturyDialogComponent,
    SimplePlatnosciTableComponent,
    HeaderZusButtonComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    NbButtonModule,
    NbCardModule,
    NbDialogModule.forChild(),
    NbIconModule,
    NbInputModule,
    NbSelectModule,
    NbSpinnerModule,
    NbToastrModule,
    TranslateModule,
    NgxDatatableModule,
    SharedPipesModule
  ],
  exports: [
    HeaderContactMenuComponent,
    MobileMessageDialogComponent,
    HeaderSaldeoButtonComponent,
    HeaderFakturyButtonComponent,
    MobileFakturyDialogComponent,
    HeaderZusButtonComponent
  ]
})
export class HeaderContactMenuModule { }
